import React from 'react'
import IconBooking from '../icons/IconBooking'
import IconAirbnb from '../icons/IconAirbnb'
import IconTripAdvisor from '../icons/IconTripAdvisor'
import IconDespegar from '../icons/IconDespegar'

const Brands = () => {
    return (
        <div className="brands gwr">
            <span>Reserva también en: </span>
            <ul className="f f-ac">
                <li>
                    <a target="_blank" rel="noopener noreferrer" href="https://www.booking.com/hotel/pe/spring-39-s.es.html">
                        <IconBooking />
                    </a>
                </li>
                <li>
                    <a target="_blank" rel="noopener noreferrer" href="https://es.airbnb.com/rooms/24099135?s=51">
                        <IconAirbnb />
                    </a>
                </li>   
                <li>
                    <a target="_blank" rel="noopener noreferrer" href="https://www.tripadvisor.co.nz/Hotel_Review-g7371306-d13948541-Reviews-Spring_s_Hotel-Pichanaqui_Junin_Region.html">
                        <IconTripAdvisor />
                    </a>
                </li>
                <li>
                    <a target="_blank" rel="noopener noreferrer" href="https://www.despegar.com.pe/hoteles/h-1258714/spring's-hotel-bajo+pichanaqui">
                        <IconDespegar />
                    </a>
                </li>
            </ul>
        </div>
    )
}

export default Brands
